import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const purpleZero = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E6F0FA',
      100: '#CCE1F5',
      200: '#99C3EB',
      300: '#66A4E1',
      400: '#3386D7',
      500: '#0065AE',
      600: '#005A9C',
      700: '#004E8A',
      800: '#004277',
      900: '#003665',
      950: '#002B53',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#0065AE',
          contrastColor: '#ffffff',
          hoverColor: '#003665',
          activeColor: '#0065AE',
        },
        highlight: {
          background: '#002B53',
          focusBackground: '#004E8A',
          color: '#ffffff',
          focusColor: '#ffffff',
        },
      },
      dark: {
        primary: {
          color: '#E6F0FA',
          contrastColor: '#002B53',
          hoverColor: '#CCE1F5',
          activeColor: '#99C3EB',
        },
        highlight: {
          background: 'rgba(80, 157, 216, .16)',
          focusBackground: 'rgba(80, 157, 216, .24)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)',
        },
      },
    },
  }
});

export default purpleZero;